import axios from 'axios';

import {
    ClientConnect, ImportError, PaginatedData, CursorPaginatedDBResponse, ClientConnectsFilters
} from 'types';

import {API_URL} from './constants';

const url = `${API_URL}/client-connect`;

const getChunkData = async (filters: ClientConnectsFilters, {next, limit}: {next: string, limit: number}):
    Promise<CursorPaginatedDBResponse<ClientConnect>> => {
    const response = await axios.post(`${url}/chunk`, {filters, next, limit});
    return response.data;
};

const getOne = async (id: string): Promise<ClientConnect> => {
    const response = await axios.post(`${url}/${id}`);
    return response.data;
};

const getAll = async (filters: ClientConnectsFilters, {page, pageSize}: {page: number, pageSize: number}):
    Promise<PaginatedData<ClientConnect>> => {
    const response = await axios.post(url, {filters, pagination: {page, pageSize}});
    return response.data;
};

const create = async (data: Partial<ClientConnect>): Promise<ClientConnect> => {
    const res = await axios.post(`${url}/create`, data);
    return res.data;
};

const update = async (id: string, data: Partial<ClientConnect>): Promise<ClientConnect> => {
    const res = await axios.put(`${url}/${id}`, data);
    return res.data;
};

const setDisabled = async (id: string, value: boolean): Promise<ClientConnect> => {
    const res = await axios.put(`${url}/${id}/disabled`, {value});
    return res.data;
};

const deleteOne = async (id: string): Promise<ClientConnect> => {
    const res = await axios.delete(`${url}/${id}`);
    return res.data;
};

const bulkDelete = async (ids: string[]): Promise<{success: string[], error: string[]}> => {
    const res = await axios.post(`${url}/bulk-delete`, ids);
    return res.data;
};

const bulkDeleteFiltered = async (filters: ClientConnectsFilters): Promise<{n: number, ok: number, deletedCount: number}> => {
    const res = await axios.post(`${url}/bulk-delete-filtered`, {filters});
    return res.data;
};

const bulkCreate = async (connects: Partial<ClientConnect>[]):
    Promise<{success: ClientConnect[], error: ImportError[]}> => {
    const res = await axios.post(`${url}/bulk-create`, connects);
    return res.data;
};

const notify = async (id: string, type: string, data: any): Promise<ClientConnect> => {
    const res = await axios.post(`${url}/${id}/notify?type=${type}`, data);
    return res.data;
};

const deleteScheduledMessage = async (connectId: string, messageId: string): Promise<ClientConnect> => {
    const res = await axios.delete(`${url}/${connectId}/${messageId}`);
    return res.data;
};

export const clientConnectApi = {
    getChunkData, getOne, getAll,
    create, update, deleteOne, bulkDelete, bulkDeleteFiltered, bulkCreate, notify, deleteScheduledMessage, setDisabled
};